$(function(e) {
    var invalid_text = Lang.get('js-return-text.error_invalid_format_message');
    var required_text = Lang.get('js-return-text.error_required_message');
    var date = new Date();
    var current_year = date.getFullYear();
    var max_thai_year = parseInt(current_year) - 12;
    var min_thai_year = parseInt(current_year) - 100;
    var min_dob_date = min_thai_year+'-01-01';
    var dob = document.getElementById("dob");
    var date_order = document.getElementById("date_order");
    var dd = date.getDate();
    var mm = date.getMonth()+1; //January is 0!
    if( dd < 10 ){
        dd = '0'+dd;
    } 
    if( mm < 10 ){
        mm = '0'+mm;
    } 
    /* var max_dob_date = current_year+'-'+mm+'-'+dd; */
    var max_dob_date = max_thai_year+'-12-31';
    var today = current_year+'-'+mm+'-'+dd;
    if( dob ){
        dob.setAttribute("min", min_dob_date);//set default min dob date    
        dob.setAttribute("max", max_dob_date);//set default max dob date
    }
    if( date_order ){
        date_order.setAttribute("max", today);//set default max dob date
    }
    
    function validateEmail(email){
      const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(email);
    }

    function validatePassword(password){
        const regex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
        return regex.test(password);
    }

    function validateDOB(dob){
        const regex = /^(0[1-9]|[12][0-9]|3[01])[\/](0[1-9]|1[012])[\/](1[0-9]|2[0-9])([0-9]{2})$/;
        return regex.test(dob);
    }

    function validateYear(dob){
        var curent_value_year = parseInt(dob.substr( dob.length - 4 ));
        if( curent_value_year >= min_thai_year && curent_value_year <= max_thai_year ){
            return true;
        }
        return false;
    }

    function addHyphen(dob) {
        let val = dob.split('/').join('');
        const regex = /^\d+$/;
        if( regex.test(val) && dob.split('/').length <= 2 ){
            let finalVal = val.match(/.{1,2}/g).join('/'); 
            return finalVal;
        }else{
            return dob;    
        }
    }
        
    function validatePhone(phone){
        const regex = /^(0?)(8|9|6)(\d{8,9})$/; 
        return regex.test(phone);
    }

    function validateName(name){
        const regex = /^[^\d]+$/;
        return regex.test(name);
    }

    function validateCardNumber(cardnumber) {
        const regex = /^(\d{16})$/; 
        return regex.test(cardnumber);
    }

    function validateCardYear(year){
        const regex = /^(1[0-9]|2[0-9])([0-9]{2})$/;
        return regex.test(year);
    }

    function validateCardMonth(month){
        const regex = /^(0[1-9]|1[012])$/;
        return regex.test(month);
    }

    function validateCardCvv(cvv){
        const regex = /^(\d{3,4})$/; 
        return regex.test(cvv);
    }


    function validateCustNo(custno){
        const regex = /^(\d{10,11})$/; 
        return regex.test(custno);
    }

    function validateOtpCode(otpcode){
        const regex = /^(\d{6})$/; 
        return regex.test(otpcode);
    }

    function validateIP(ip){
        const regex = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/; 
        return regex.test(ip);
    }

    $('body').on("change", "input[type=checkbox][name=policy]:not(.not_validate)", function(e) {
        if(this.checked) {
            $(this).removeClass('is-invalid');
        }
    });

    $('body').on("change paste keyup", "input[type=number]:not(.not_validate),input[type=text]:not(.not_validate),textarea:not(.not_validate), select:not(.not_validate)", function(e) {
        if ( $(this).hasClass('is-invalid') ) {
            if ( $(this).val() !== '' ) {
                $(this).removeClass('is-invalid');
                $(this).parent().removeClass('invalid-field');
                $(this).parent().addClass('valid-field');
                $(this).addClass('is-valid');
            }
        } else {
            if ($(this).val() == '') {
                $(this).removeClass('is-valid');
                $(this).addClass('is-invalid');
                $(this).parent().addClass('invalid-field');
                $(this).parent().removeClass('valid-field');
            } else {
                $(this).parent().removeClass('invalid-field');
                $(this).parent().addClass('valid-field');
                $(this).addClass('is-valid');
            }
        }
    });

    $('body').on("change paste keyup", "input[name=password]:not(.not_validate),input[type=password]:not(.not_validate)", function(e){
        if ( validatePassword( $(this).val() ) ) {
            $(this).removeClass('is-invalid');
            $(this).addClass('is-valid');
            $(this).parent().parent().removeClass('invalid-field');
            $(this).parent().parent().addClass('valid-field');
        }else{
            $(this).addClass('is-invalid'); 
            $(this).removeClass('is-valid');
            $(this).parent().parent().addClass('invalid-field');
            $(this).parent().parent().removeClass('valid-field');
            if( $(this).val() == '' ){
                $(this).parent().parent().children('.form-label-wrap').children('.invalid-feedback').html(required_text);
            }else{
                $(this).parent().parent().children('.form-label-wrap').children('.invalid-feedback').html(invalid_text);    
            }
        }
    });

    $('body').on("change paste keyup", "input[type=text]:not(.not_validate).ignore_empty,input[name=password]:not(.not_validate).ignore_empty,input[type=password]:not(.not_validate).ignore_empty", function(e){
        if( $(this).val().length == 0 ){
            $(this).removeClass('is-invalid');
            $(this).parent().parent().removeClass('invalid-field');
        }
    });

    $('body').on("change paste keyup", "input[type=name]:not(.not_validate)", function(e){
        if ( validateName( $(this).val() ) ) {
            $(this).removeClass('is-invalid');
            $(this).addClass('is-valid');
            $(this).parent().removeClass('invalid-field');
            $(this).parent().addClass('valid-field');
        }else{
            $(this).addClass('is-invalid'); 
            $(this).removeClass('is-valid');
            $(this).parent().addClass('invalid-field');
            $(this).parent().removeClass('valid-field');
            if( $(this).val() == '' ){
                $(this).parent().children('.form-label-wrap').children('.invalid-feedback').html(required_text);
            }else{
                $(this).parent().children('.form-label-wrap').children('.invalid-feedback').html(invalid_text);    
            }
        }
    });

    $('body').on("change paste keyup", "input[type=email]:not(.not_validate)", function(e){
        if ( validateEmail( $(this).val() ) ) {
            $(this).removeClass('is-invalid');
            $(this).addClass('is-valid');
            $(this).parent().removeClass('invalid-field');
            $(this).parent().addClass('valid-field');
        }else{
            $(this).addClass('is-invalid'); 
            $(this).removeClass('is-valid');
            $(this).parent().addClass('invalid-field');
            $(this).parent().removeClass('valid-field');
            if( $(this).val() == '' ){
                $(this).parent().children('.form-label-wrap').children('.invalid-feedback').html(required_text);
            }else{
                $(this).parent().children('.form-label-wrap').children('.invalid-feedback').html(invalid_text);    
            }
        }
    });

    $('body').on("change keyup", "input[name=dob]:not(.not_validate).input-dob", function(e){
        $(this).removeClass('empty-dob');
        if( $(this).val() ){
            if ( validateYear($(this).val().slice(0, 4)) ) {
                $(this).removeClass('is-invalid');
                $(this).addClass('is-valid');
                $(this).parent().removeClass('invalid-field');
                $(this).parent().addClass('valid-field');
            }else{
                 $(this).addClass('is-invalid'); 
                $(this).removeClass('is-valid');
                $(this).parent().addClass('invalid-field');
                $(this).parent().removeClass('valid-field');
                if( $(this).val() == '' ){
                    $(this).parent().children('.form-label-wrap').children('.invalid-feedback').html(required_text);
                }else{
                    $(this).parent().children('.form-label-wrap').children('.invalid-feedback').html(invalid_text);    
                }
            }
        }
    });

    $('body').on("change paste keyup", "input[name=phone]:not(.not_validate),input[type=phone]:not(.not_validate)", function(e){
        if ( validatePhone( $(this).val() ) ) {
            $(this).removeClass('is-invalid');
            $(this).addClass('is-valid');
            $(this).parent().removeClass('invalid-field');
            $(this).parent().addClass('valid-field');
        }else{
            $(this).addClass('is-invalid'); 
            $(this).removeClass('is-valid');
            $(this).parent().addClass('invalid-field');
            $(this).parent().removeClass('valid-field');
            if( $(this).val() == '' ){
                $(this).parent().children('.form-label-wrap').children('.invalid-feedback').html(required_text);
            }else{
                $(this).parent().children('.form-label-wrap').children('.invalid-feedback').html(invalid_text);    
            }
        }
    });

    $('body').on("change paste keyup", "input[name=cardholder_name]:not(.not_validate)", function(e){
        if ( validateName( $(this).val() ) ) {
            $(this).removeClass('is-invalid');
            $(this).addClass('is-valid');
            $(this).parent().removeClass('invalid-field');
            $(this).parent().addClass('valid-field');
        }else{
            $(this).addClass('is-invalid'); 
            $(this).removeClass('is-valid');
            $(this).parent().addClass('invalid-field');
            $(this).parent().removeClass('valid-field');
            if( $(this).val() == '' ){
                $(this).parent().children('.invalid-feedback').html(required_text);
            }else{
                $(this).parent().children('.invalid-feedback').html(invalid_text);    
            }
        }
    });

    $('body').on("change paste keyup", "input[name=cardnumber]:not(.not_validate)", function(e){
        if ( validateCardNumber( $(this).val() ) ) {
            $(this).removeClass('is-invalid');
            $(this).addClass('is-valid');
            $(this).parent().removeClass('invalid-field');
            $(this).parent().addClass('valid-field');
        }else{
            $(this).addClass('is-invalid'); 
            $(this).removeClass('is-valid');
            $(this).parent().addClass('invalid-field');
            $(this).parent().removeClass('valid-field');
            if( $(this).val() == '' ){
                $(this).parent().children('.invalid-feedback').html(required_text);
            }else{
                $(this).parent().children('.invalid-feedback').html(invalid_text);    
            }
        }
    });

    $('body').on("change paste keyup", "input[name=year]:not(.not_validate)", function(e){
        if ( validateCardYear( $(this).val() ) ) {
            $(this).removeClass('is-invalid');
            $(this).addClass('is-valid');
            $(this).parent().removeClass('invalid-field');
            $(this).parent().addClass('valid-field');
        }else{
            $(this).addClass('is-invalid'); 
            $(this).removeClass('is-valid');
            $(this).parent().addClass('invalid-field');
            $(this).parent().removeClass('valid-field');
            if( $(this).val() == '' ){
                $(this).parent().children('.invalid-feedback').html(required_text);
            }else{
                $(this).parent().children('.invalid-feedback').html(invalid_text);    
            }
        }
    });

    $('body').on("change paste keyup", "input[name=month]:not(.not_validate)", function(e){
        if ( validateCardMonth( $(this).val() ) ) {
            $(this).removeClass('is-invalid');
            $(this).addClass('is-valid');
            $(this).parent().removeClass('invalid-field');
            $(this).parent().addClass('valid-field');
        }else{
            $(this).addClass('is-invalid'); 
            $(this).removeClass('is-valid');
            $(this).parent().addClass('invalid-field');
            $(this).parent().removeClass('valid-field');
            if( $(this).val() == '' ){
                $(this).parent().children('.invalid-feedback').html(required_text);
            }else{
                $(this).parent().children('.invalid-feedback').html(invalid_text);    
            }
        }
    });

    $('body').on("change paste keyup", "input[name=cvv]:not(.not_validate)", function(){
        if ( validateCardCvv( $(this).val() ) ) {
            $(this).removeClass('is-invalid');
            $(this).addClass('is-valid');
            $(this).parent().removeClass('invalid-field');
            $(this).parent().addClass('valid-field');
        }else{
            $(this).addClass('is-invalid'); 
            $(this).removeClass('is-valid');
            $(this).parent().addClass('invalid-field');
            $(this).parent().removeClass('valid-field');
            if( $(this).val() == '' ){
                $(this).parent().children('.invalid-feedback').html(required_text);
            }else{
                $(this).parent().children('.invalid-feedback').html(invalid_text);    
            }
        }
    });

    $('body').on("change paste keyup", "input[type=ip]:not(.not_validate)", function(){
        if ( validateIP( $(this).val() ) ) {
            $(this).removeClass('is-invalid');
            $(this).addClass('is-valid');
            $(this).parent().removeClass('invalid-field');
            $(this).parent().addClass('valid-field');
        }else{
            $(this).addClass('is-invalid'); 
            $(this).removeClass('is-valid');
            $(this).parent().addClass('invalid-field');
            $(this).parent().removeClass('valid-field');
            if( $(this).val() == '' ){
                $(this).parent().children('.invalid-feedback').html(required_text);
            }else{
                $(this).parent().children('.invalid-feedback').html(invalid_text);    
            }
        }
    });

    $('body').on("change paste keyup", "input[name=custno]:not(.not_validate)", function(){
        if ( validateCustNo( $(this).val() ) ) {
            $(this).removeClass('is-invalid');
            $(this).addClass('is-valid');
            $(this).parent().removeClass('invalid-field');
            $(this).parent().addClass('valid-field');
        }else{
            $(this).addClass('is-invalid'); 
            $(this).removeClass('is-valid');
            $(this).parent().addClass('invalid-field');
            $(this).parent().removeClass('valid-field');
            if( $(this).val() == '' ){
                $(this).parent().children('.invalid-feedback').html(required_text);
            }else{
                $(this).parent().children('.invalid-feedback').html(invalid_text);    
            }
        }
    });

    $('body').on("change paste keyup", "input[name=otp_code]:not(.not_validate)", function(){
        if ( validateOtpCode( $(this).val() ) ) {
            $(this).removeClass('is-invalid');
            $(this).addClass('is-valid');
            $(this).parent().removeClass('invalid-field');
            $(this).parent().addClass('valid-field');
        }else{
            $(this).addClass('is-invalid'); 
            $(this).removeClass('is-valid');
            $(this).parent().addClass('invalid-field');
            $(this).parent().removeClass('valid-field');
            if( $(this).val() == '' ){
                $(this).parent().children('.invalid-feedback').html(required_text);
            }else{
                $(this).parent().children('.invalid-feedback').html(invalid_text);
            }
        }
    });
    
    $('body').on("change paste keyup", 'form input, form textarea, form select', function(e){
        if( $(this).parents('form').hasClass('form-validate') ){
            if( $(this).hasClass('is-invalid') ){
                $(this).parents('form').find('button[type=submit]').attr('disabled', 'disabled');
            }else{
                $(this).parents('form').find('button[type=submit]').removeAttr('disabled');
            }
        }
    });
});